module.exports = __webpack_public_path__ + "static/directory_3@2x-b5d27185b81234a6356e110ef47e17cf.png";